var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('CardIeaAppMain',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"text-center"},[_vm._v("Cargando datos de Pago...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }